import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  return <section className="min-h-screen flex flex-col justify-center items-center px-4 md:px-8 py-20 bg-[#FAFAFA] relative overflow-hidden" data-id="element-37">
      {/* Abstract background element */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#F59E0B]" data-id="element-38" />

      <div className="max-w-7xl mx-auto z-10 w-full" data-id="element-39">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-40">
          {/* Left: Text Content */}
          <div className="text-center md:text-left" data-id="element-41">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} data-id="element-42">
              <span className="inline-block py-1 px-3 rounded-full bg-amber-100 text-amber-800 text-sm font-bold tracking-wide mb-6" data-id="element-43">
                NUEVO LANZAMIENTO
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'easeOut'
          }} className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#1A1A1A] tracking-tight leading-[1.1] mb-8" data-id="element-44">
              Juega Desde <br data-id="element-45" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#D97706]" data-id="element-46">
                Otro Nivel
              </span>
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4,
            ease: 'easeOut'
          }} className="mb-12" data-id="element-47">
              <p className="text-xl md:text-2xl text-gray-900 font-medium leading-relaxed mb-4" data-id="element-48">
                No te falta hacer Más
                <br data-id="element-49" />
                Te falta un nuevo nivel de juego
              </p>

              <p className="text-lg text-gray-600 mb-6" data-id="element-50">
                Para profesionales de la venta que ya tienen resultados... pero
                que sienten un techo invisible.
              </p>

              <ul className="space-y-3 text-left" data-id="element-51">
                <li className="flex items-start gap-3 text-gray-700" data-id="element-52">
                  <span className="text-amber-500 font-bold mt-1" data-id="element-53">•</span>
                  <span data-id="element-54">
                    Identifica dónde se te va el día (sin juicio, con verdad)
                  </span>
                </li>
                <li className="flex items-start gap-3 text-gray-700" data-id="element-55">
                  <span className="text-amber-500 font-bold mt-1" data-id="element-56">•</span>
                  <span data-id="element-57">Recupera energía al eliminar lo que no te suma</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700" data-id="element-58">
                  <span className="text-amber-500 font-bold mt-1" data-id="element-59">•</span>
                  <span data-id="element-60">
                    Enfócate en lo que mueve la aguja (80/20 real, sin
                    romanticismo)
                  </span>
                </li>
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.6,
            ease: 'easeOut'
          }} data-id="element-61">
              <CTAButton href="https://coneckta.co/ebookjuegadesdeotronivel" data-id="element-62">
                Accede ahora a Juega Desde Otro Nivel
              </CTAButton>
            </motion.div>
          </div>

          {/* Right: Hero Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1,
          delay: 0.4,
          ease: 'easeOut'
        }} className="relative" data-id="element-63">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-64">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766416077/Portada_k7wqrn.jpg" alt="Juega Desde Otro Nivel - Portada del libro" className="w-full h-auto object-cover" data-id="element-65" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}